import script from "./Checkboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkboard.vue?vue&type=script&lang=ts&setup=true"

import "./Checkboard.vue?vue&type=style&index=0&id=fa191ace&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa191ace"]])

export default __exports__